import React from 'react';
import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ApiService from '../../services/ApiService';
import { useHistory } from 'react-router-dom';
import './setting.css';
import CustomInput from '../../components/Elements/input/customInput';
import CustomRedText from '../../components/Elements/redText/redText';
import CustomButtons from '../../components/Elements/Buttons/customButton';
import PersonalData from './personalData/personalData';
import CoursBar from '../../components/pulpit/cours_bar';
import { API_URL } from '../../config';
import axios from 'axios';
import YoursConsent from './yoursConsent/yoursConsent';
import ChooseUserOption from '../chooseUserBuy/chooseUser/chooseUserOption/chooseUserOption';
import Rodo from './rodo/rodo';
import { Container, Row, Col } from 'react-bootstrap';
import AcceptInput from '../chooseUserBuy/accept/accept.js';
import StatueApp from './statueApp/satueApp';
const Setting = (props) => {
    const apiService = new ApiService();
    const [isDebet, setIsDebet] = useState(true);
    const [creditsCard, setCreditCards] = useState([]);
    const history = useHistory();
    const [msgTitle, setMsgTitle] = useState('');
    const [msg, setMsg] = useState('');
    
    const [relUser, setRelUser] = useState([]);
    const [choosenBar, setChoosenBar] = useState({
        user: null,
        otherUsers: null,
    });
    const [chosenCard, setChosenCard] = useState()
    const [lenguage, setLenguage] = useState('pl');
    const [formData, setFromData] = useState({
        oldPassword: '',
        password: '',
        repeatedPassword: '',
    });
    const [formDataValidaiton, setFormDataValidaiton] = useState({
        oldPassword: true,
        password: true,
        repeatedPassword: true,
    });
    const getSubaccountsURL = `${API_URL}GetSubaccounts`;
    const config = { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } };
    let choosenUser = [];
    let [defaultCard, setDefultCard] = useState([]);

    useEffect(() => {
        const payload = { usersID: props.userID, current_LocalizationsID: 0 };
        apiService.apiPost('getUserCards', payload, (response2) => {
       
            if (response2.success) {
     if(response2.data.length != 0){
                setCreditCards(response2.data);
            for(var i = 0; i < response2.data.length; i++){
                if(response2.data[i].defaultCard){
                    chosenCard(response2.data[i].paymentCardID)
                }
            }}
            } else {
                // end(false);
            }
        });

        axios
            .get(getSubaccountsURL, config)
            .then((response) => {
         

                setRelUser(response.data);
            })
            .catch(function (error) {
                if (error.response.status == 401) {
                    history.push('/Error_sesja_wygasla');
                }
            });
    }, [props.userID]);

    const save = (e) => {
        e.preventDefault();

        const proceed = () => {
            const payload = {
                password: formData.oldPassword,
                newpassword: formData.password,
            };

            apiService.apiPost('UserResetPassword', payload, (response) => {
                if (response.success) {
                    setMsg('Hasło zostało zmienione');
                    // if (typeof response.data.succeeded === 'boolean' && response.data.succeeded) {

                    // force user to login after changing password
                    // apiService.logout(false);
                    // history.push('/login_haslo_zmienione');

                    // } else {
                    // }
                } else {
                    if (response.data.message == 'Błędne hasło.') {
                        setMsg('Stare hasło jest błędne');
                    } else {
                        setMsg('Wystąpił nierozponany problem');
                        // notificationService.showError();
                    }
                }
            });
        };

        if (typeof formData.oldPassword === 'string' && formData.oldPassword.length > 0) {
            if (typeof formData.password === 'string' && formData.password.length > 0) {
                if (
                    typeof formData.repeatedPassword === 'string' &&
                    formData.repeatedPassword.length > 0
                ) {
                    if (formData.password === formData.repeatedPassword) {
                        proceed();
                    } else {
                        setMsg('Wpisane hasła nie pasują do siebie');
                    }
                } else {
                    setMsg('Nie wpisano powtórzonego hasła');
                }
            } else {
                setMsg('Nie wpisano hasła');
            }
        } else {
            setMsg('Nie wpisano starego hasła');
        }
    };
    useEffect(() => {
        props.setHeader('/  USTAWIENIA');
    }, []);

    function changeView() {
        setIsDebet(!isDebet);
    }
    function registerNewCard() {
     
        const cardData = {
            usersID: props.userID,
            localizationsID: '2',
            current_LocalizationsID: '2',
            returnURL: 'Setting/',
        };

        apiService.apiPost('RegisterCard', cardData, (response) => {
            const error = () => {
                this.notificationService.showError();
            };

            if (
                response.success &&
                typeof response.data === 'object' &&
                response.data !== null &&
                response.data.succeeded === true &&
                typeof response.data.responseBody === 'object' &&
                response.data.responseBody !== null &&
                response.data.responseBody.status === 200 &&
                typeof response.data.responseBody.body === 'string'
            ) {
                try {
                    const p24Response = JSON.parse(response.data.responseBody.body);
                    if (typeof p24Response.url === 'string' && p24Response.url.length > 0) {
                        window.location.replace(p24Response.url);
                    } else {
                 
                        error();
                    }
                } catch (ex) {
                 
                    error();
                }
            } else {
        
                error();
            }
        });
    }
    function changeSide(e, side, msg) {
        e.preventDefault();
        props.setSide(side);
        setMsgTitle(msg);
    }

    // <CustomInput title="Hasło" isRequied={true} onChangeInput={setPassword}></CustomInput>
    return (
        <>
       
            <div className="dashboard__content">
                {props.side != 0 ? (
                    <div className={props.side != 7 ? 'backButton_container' : 'onlyBackButtonContainer'}>
                        {props.side != 7 ? <p>{msgTitle}</p> : ''}

                        
                    </div>
                ) : (
                    ''
                )}
                <main>
                    <div className="setting">
                        {props.side == 0 ? (
                            <div className="settingMenu_container">
                                <p
                                    className="settingMenu_buton"
                                    onClick={(e) => {
                                        changeSide(e, 2, 'Metody płatności');
                                    }}
                                >
                                    <svg
                                        className="dashboard__btn-arrow"
                                        viewBox="0 0 24 11"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                        fill="#CC0033"
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M0 5.5C0 5.29165 0.085593 5.09184 0.237949 4.94452C0.390306 4.79719 0.596945 4.71443 0.812409 4.71443H10.225L6.7365 1.34275C6.58395 1.19524 6.49825 0.995175 6.49825 0.786565C6.49825 0.577955 6.58395 0.377889 6.7365 0.23038C6.88905 0.0828702 7.09595 0 7.31168 0C7.52742 0 7.73432 0.0828702 7.88687 0.23038L12.7613 4.94381C12.837 5.01679 12.897 5.10348 12.938 5.19892C12.9789 5.29436 13 5.39667 13 5.5C13 5.60333 12.9789 5.70564 12.938 5.80108C12.897 5.89652 12.837 5.98321 12.7613 6.05619L7.88687 10.7696C7.73432 10.9171 7.52742 11 7.31168 11C7.09595 11 6.88905 10.9171 6.7365 10.7696C6.58395 10.6221 6.49825 10.422 6.49825 10.2134C6.49825 10.0048 6.58395 9.80476 6.7365 9.65725L10.225 6.28557H0.812409C0.596945 6.28557 0.390306 6.20281 0.237949 6.05548C0.085593 5.90816 0 5.70835 0 5.5Z"
                                        />
                                    </svg>
                                    Metody płatności
                                </p>
                                <p
                                    className="settingMenu_buton"
                                    onClick={(e) => {
                                        changeSide(e, 1, 'Ustawienia konta');
                                    }}
                                >
                                    <svg
                                        className="dashboard__btn-arrow"
                                        viewBox="0 0 24 11"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                        fill="#CC0033"
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M0 5.5C0 5.29165 0.085593 5.09184 0.237949 4.94452C0.390306 4.79719 0.596945 4.71443 0.812409 4.71443H10.225L6.7365 1.34275C6.58395 1.19524 6.49825 0.995175 6.49825 0.786565C6.49825 0.577955 6.58395 0.377889 6.7365 0.23038C6.88905 0.0828702 7.09595 0 7.31168 0C7.52742 0 7.73432 0.0828702 7.88687 0.23038L12.7613 4.94381C12.837 5.01679 12.897 5.10348 12.938 5.19892C12.9789 5.29436 13 5.39667 13 5.5C13 5.60333 12.9789 5.70564 12.938 5.80108C12.897 5.89652 12.837 5.98321 12.7613 6.05619L7.88687 10.7696C7.73432 10.9171 7.52742 11 7.31168 11C7.09595 11 6.88905 10.9171 6.7365 10.7696C6.58395 10.6221 6.49825 10.422 6.49825 10.2134C6.49825 10.0048 6.58395 9.80476 6.7365 9.65725L10.225 6.28557H0.812409C0.596945 6.28557 0.390306 6.20281 0.237949 6.05548C0.085593 5.90816 0 5.70835 0 5.5Z"
                                        />
                                    </svg>
                                    Ustawienia konta
                                </p>
                                <p
                                    className="settingMenu_buton"
                                    onClick={(e) => {
                                        changeSide(e, 3, 'Informacje kontaktowe');
                                    }}
                                >
                                    <svg
                                        className="dashboard__btn-arrow"
                                        viewBox="0 0 24 11"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                        fill="#CC0033"
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M0 5.5C0 5.29165 0.085593 5.09184 0.237949 4.94452C0.390306 4.79719 0.596945 4.71443 0.812409 4.71443H10.225L6.7365 1.34275C6.58395 1.19524 6.49825 0.995175 6.49825 0.786565C6.49825 0.577955 6.58395 0.377889 6.7365 0.23038C6.88905 0.0828702 7.09595 0 7.31168 0C7.52742 0 7.73432 0.0828702 7.88687 0.23038L12.7613 4.94381C12.837 5.01679 12.897 5.10348 12.938 5.19892C12.9789 5.29436 13 5.39667 13 5.5C13 5.60333 12.9789 5.70564 12.938 5.80108C12.897 5.89652 12.837 5.98321 12.7613 6.05619L7.88687 10.7696C7.73432 10.9171 7.52742 11 7.31168 11C7.09595 11 6.88905 10.9171 6.7365 10.7696C6.58395 10.6221 6.49825 10.422 6.49825 10.2134C6.49825 10.0048 6.58395 9.80476 6.7365 9.65725L10.225 6.28557H0.812409C0.596945 6.28557 0.390306 6.20281 0.237949 6.05548C0.085593 5.90816 0 5.70835 0 5.5Z"
                                        />
                                    </svg>
                                    Informacje kontaktowe
                                </p>
                                <p
                                    className="settingMenu_buton"
                                    onClick={(e) => {
                                        changeSide(e, 4, 'Twoje zgody');
                                    }}
                                ><svg
                                        className="dashboard__btn-arrow"
                                        viewBox="0 0 24 11"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                        fill="#CC0033"
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M0 5.5C0 5.29165 0.085593 5.09184 0.237949 4.94452C0.390306 4.79719 0.596945 4.71443 0.812409 4.71443H10.225L6.7365 1.34275C6.58395 1.19524 6.49825 0.995175 6.49825 0.786565C6.49825 0.577955 6.58395 0.377889 6.7365 0.23038C6.88905 0.0828702 7.09595 0 7.31168 0C7.52742 0 7.73432 0.0828702 7.88687 0.23038L12.7613 4.94381C12.837 5.01679 12.897 5.10348 12.938 5.19892C12.9789 5.29436 13 5.39667 13 5.5C13 5.60333 12.9789 5.70564 12.938 5.80108C12.897 5.89652 12.837 5.98321 12.7613 6.05619L7.88687 10.7696C7.73432 10.9171 7.52742 11 7.31168 11C7.09595 11 6.88905 10.9171 6.7365 10.7696C6.58395 10.6221 6.49825 10.422 6.49825 10.2134C6.49825 10.0048 6.58395 9.80476 6.7365 9.65725L10.225 6.28557H0.812409C0.596945 6.28557 0.390306 6.20281 0.237949 6.05548C0.085593 5.90816 0 5.70835 0 5.5Z"
                                        />
                                    </svg>
                                    Twoje zgody
                                </p>
                                <p
                                    className="settingMenu_buton"
                                    onClick={(e) => {
                                        changeSide(e, 5, 'Język aplikacji');
                                    }}
                                ><svg
                                className="dashboard__btn-arrow"
                                viewBox="0 0 24 11"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                fill="#CC0033"
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M0 5.5C0 5.29165 0.085593 5.09184 0.237949 4.94452C0.390306 4.79719 0.596945 4.71443 0.812409 4.71443H10.225L6.7365 1.34275C6.58395 1.19524 6.49825 0.995175 6.49825 0.786565C6.49825 0.577955 6.58395 0.377889 6.7365 0.23038C6.88905 0.0828702 7.09595 0 7.31168 0C7.52742 0 7.73432 0.0828702 7.88687 0.23038L12.7613 4.94381C12.837 5.01679 12.897 5.10348 12.938 5.19892C12.9789 5.29436 13 5.39667 13 5.5C13 5.60333 12.9789 5.70564 12.938 5.80108C12.897 5.89652 12.837 5.98321 12.7613 6.05619L7.88687 10.7696C7.73432 10.9171 7.52742 11 7.31168 11C7.09595 11 6.88905 10.9171 6.7365 10.7696C6.58395 10.6221 6.49825 10.422 6.49825 10.2134C6.49825 10.0048 6.58395 9.80476 6.7365 9.65725L10.225 6.28557H0.812409C0.596945 6.28557 0.390306 6.20281 0.237949 6.05548C0.085593 5.90816 0 5.70835 0 5.5Z"
                                />
                            </svg>
                                    Język aplikacji
                                </p>
                                <p
                                    className="settingMenu_buton"
                                    onClick={(e) => {
                                        changeSide(e, 6, 'Regulamin aplikacji');
                                    }}
                                ><svg
                                className="dashboard__btn-arrow"
                                viewBox="0 0 24 11"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                fill="#CC0033"
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M0 5.5C0 5.29165 0.085593 5.09184 0.237949 4.94452C0.390306 4.79719 0.596945 4.71443 0.812409 4.71443H10.225L6.7365 1.34275C6.58395 1.19524 6.49825 0.995175 6.49825 0.786565C6.49825 0.577955 6.58395 0.377889 6.7365 0.23038C6.88905 0.0828702 7.09595 0 7.31168 0C7.52742 0 7.73432 0.0828702 7.88687 0.23038L12.7613 4.94381C12.837 5.01679 12.897 5.10348 12.938 5.19892C12.9789 5.29436 13 5.39667 13 5.5C13 5.60333 12.9789 5.70564 12.938 5.80108C12.897 5.89652 12.837 5.98321 12.7613 6.05619L7.88687 10.7696C7.73432 10.9171 7.52742 11 7.31168 11C7.09595 11 6.88905 10.9171 6.7365 10.7696C6.58395 10.6221 6.49825 10.422 6.49825 10.2134C6.49825 10.0048 6.58395 9.80476 6.7365 9.65725L10.225 6.28557H0.812409C0.596945 6.28557 0.390306 6.20281 0.237949 6.05548C0.085593 5.90816 0 5.70835 0 5.5Z"
                                />
                            </svg>
                                    Regulamin aplikacji
                                </p>
                                <p
                                    className="settingMenu_buton"
                                    onClick={(e) => {
                                        changeSide(e, 7, 'Polityka prywantości');
                                    }}
                                ><svg
                                className="dashboard__btn-arrow"
                                viewBox="0 0 24 11"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                fill="#CC0033"
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M0 5.5C0 5.29165 0.085593 5.09184 0.237949 4.94452C0.390306 4.79719 0.596945 4.71443 0.812409 4.71443H10.225L6.7365 1.34275C6.58395 1.19524 6.49825 0.995175 6.49825 0.786565C6.49825 0.577955 6.58395 0.377889 6.7365 0.23038C6.88905 0.0828702 7.09595 0 7.31168 0C7.52742 0 7.73432 0.0828702 7.88687 0.23038L12.7613 4.94381C12.837 5.01679 12.897 5.10348 12.938 5.19892C12.9789 5.29436 13 5.39667 13 5.5C13 5.60333 12.9789 5.70564 12.938 5.80108C12.897 5.89652 12.837 5.98321 12.7613 6.05619L7.88687 10.7696C7.73432 10.9171 7.52742 11 7.31168 11C7.09595 11 6.88905 10.9171 6.7365 10.7696C6.58395 10.6221 6.49825 10.422 6.49825 10.2134C6.49825 10.0048 6.58395 9.80476 6.7365 9.65725L10.225 6.28557H0.812409C0.596945 6.28557 0.390306 6.20281 0.237949 6.05548C0.085593 5.90816 0 5.70835 0 5.5Z"
                                />
                            </svg>
                                    Polityka prywatności, RODO
                                </p>
                            </div>
                        ) : (
                            ''
                        )}
                        {props.side == 7 ? (
                            <div className="personalData_wrapper">
                                <Rodo></Rodo>
                            </div>
                        ) : (
                            ''
                        )}
                        {props.side == 6 ? (
                            <div className="personalData_wrapper">
                                <StatueApp></StatueApp>
                            </div>
                        ) : (
                            ''
                        )}
                        {props.side == 5 ? (
                            <div className="personalData_wrapper lengu">
                                <ChooseUserOption
                                    isChekcked={lenguage == 'pl'}
                                    onCheck={(e) => {
                                        setLenguage('pl');
                                    }}
                                    label="polski"
                                ></ChooseUserOption>
                            </div>
                        ) : (
                            ''
                        )}
                        {props.side == 4 ? <YoursConsent userData={props.userData}></YoursConsent> : ''}
                        {props.side == 3 ? (
                            <div className="personalData_wrapper">
                                <p className="infoPersonalData">
                                    Celem zmiany danych skontaktuj się z Recepcją Szkoły
                                </p>
                                <div style={{ height: '20px' }}></div>
                                <div className="ShadowBox_data"
                               
                                    
                                >Twoje dane
                                <CustomButtons clickFunction={(status) => {
                                        if (choosenBar.user == 0) {
                                            setChoosenBar({ user: null });
                                        } else {
                                            setChoosenBar({ user: 0 });
                                        }
                                    }} size="small" classButton={choosenBar.user == 0?"solid":"outline"} >{choosenBar.user == 0?"MNIEJ":"ZOBACZ"}</CustomButtons></div>

                                {choosenBar.user == 0 ? (
                                    <PersonalData userData={props.userData}></PersonalData>
                                ) : (
                                    ''
                                )}
                                <div style={{ height: '20px' }}></div>
                               
                                 <div className="ShadowBox_data"
                               
                                    
                               >Użytkownicy powiązani
                               <CustomButtons clickFunction={(status) => {
                                       if (choosenBar.otherUsers == 0) {
                                           setChoosenBar({ otherUsers: null });
                                       } else {
                                           setChoosenBar({ otherUsers: 0 });
                                       }
                                   }} size="small" classButton={choosenBar.otherUsers == 0?"solid":"outline"} >{choosenBar.otherUsers == 0?"MNIEJ":"ZOBACZ"}</CustomButtons></div>
                                   <div style={{ height: '20px' }}></div>
                                {choosenBar.otherUsers == 0 ? (
                                    relUser.length != 0 ? (
                                        relUser.map((user, index) => {
                                           
                                            let roller = false;
                                            return (
                                                <div
                                                    className="personalData_user"
                                                    
                                                >
                                                    {' '}
                                                    <CoursBar
                                                        onSelect={(status) => {
                                                            if (choosenBar.user == index + 1) {
                                                                setChoosenBar({
                                                                    user: null,
                                                                    otherUsers: 0,
                                                                });
                                                            } else {
                                                                setChoosenBar({
                                                                    user: index + 1,
                                                                    otherUsers: 0,
                                                                });
                                                            }
                                                        }}
                                                        name={user.firstName + ' ' + user.lastName}
                                                    ></CoursBar>
                                                    {choosenBar.user == index + 1 ? (
                                                        <PersonalData
                                                            userData={user}
                                                        ></PersonalData>
                                                    ) : (
                                                        ''
                                                    )}
                                                </div>
                                            );
                                        })
                                    ) : (
                                        <p className="infoPersonalData">
                                            Brak informacji do wyświetlenia
                                        </p>
                                    )
                                ) : (
                                    ''
                                )}
                            </div>
                        ) : (
                            ''
                        )}
                        {props.side == 1 ? (
                            <div className="changePassword_section">
                                <div className="changePassword_section-title">Zmień hasło</div>
                                <div style={{ height: '20px' }}></div>

                                <div className="changePassword">
                                    <CustomInput
                                        showCalendary={(e) => {}}
                                        validation={formDataValidaiton.oldPassword}
                                        onChangeInput={(e) => {
                                            if (e != '') {
                                                setFromData({
                                                    ...formData,
                                                    ...{ oldPassword: e },
                                                });
                                                setFormDataValidaiton({
                                                    ...formDataValidaiton,
                                                    ...{ oldPassword: true },
                                                });
                                            } else {
                                                setFormDataValidaiton({
                                                    ...formDataValidaiton,
                                                    ...{ oldPassword: false },
                                                });
                                            }
                                        }}
                                        isRequied={true}
                                        title="Stare hasło"
                                    ></CustomInput>
                                    <CustomInput
                                        showCalendary={(e) => {}}
                                        validation={formDataValidaiton.password}
                                        onChangeInput={(e) => {
                                            if (e != '') {
                                                setFromData({
                                                    ...formData,
                                                    ...{ password: e },
                                                });
                                                setFormDataValidaiton({
                                                    ...formDataValidaiton,
                                                    ...{ password: true },
                                                });
                                            } else {
                                                setFormDataValidaiton({
                                                    ...formDataValidaiton,
                                                    ...{ password: false },
                                                });
                                            }
                                        }}
                                        isRequied={true}
                                        title="Nowe hasło"
                                    ></CustomInput>
                                    <CustomInput
                                        showCalendary={(e) => {}}
                                        validation={formDataValidaiton.repeatedPassword}
                                        onChangeInput={(e) => {
                                            if (e != '') {
                                                setFromData({
                                                    ...formData,
                                                    ...{ repeatedPassword: e },
                                                });
                                                setFormDataValidaiton({
                                                    ...formDataValidaiton,
                                                    ...{ repeatedPassword: true },
                                                });
                                            } else {
                                                setFormDataValidaiton({
                                                    ...formDataValidaiton,
                                                    ...{ repeatedPassword: false },
                                                });
                                            }
                                        }}
                                        isRequied={true}
                                        title="Powtórz hasło"
                                    ></CustomInput>
                                    <div style={{ height: '20px' }}></div>
                                    <div
                                        
                                    >
                                        <CustomButtons
                                            clickFunction={(e) => {
                                                save(e);
                                            }}
                                            classButton="solid"
                                            size="small"
                                        >
                                            ZMIEŃ HASŁO
                                        </CustomButtons>
                                    </div>
                                    {msg != '' ? <p className="errorText">{msg}</p> : ''}
                                </div>
                            </div>
                        ) : (
                            ''
                        )}
                        {props.side == 2 ? (
                            <div className="debetCard_section">
                                <div className="section__h6-headline" style={{ fontWeight: '700' }}>
                                    Twoje karty
                                </div>
                                <div className="debetCard">
                                    <div>
                                       
                                        {creditsCard.length > 0 ? (
                                            creditsCard.map((card, index) => {
                                         
                                                return (
                                                    <div className="cardView">
                                                        <ChooseUserOption paymentOption={"A"} isChekcked={chosenCard == card.paymentCardID} onCheck={()=>{setChosenCard(card.paymentCardID)}}></ChooseUserOption>
                                                        <p className="cardViewType">
                                                            {card.cardType}:
                                                        </p>
                                                        <p>{card.mask}</p>
                                                    </div>
                                                );
                                            })
                                        ) : (
                                            <div
                                                className="section__h6-headline"
                                                style={{ marginTop: '20px' }}
                                            >
                                                Nie podpiąłeś jeszcze żadnej karty
                                            </div>
                                        )}
                                    </div>
                                    <CustomButtons
                                        clickFunction={(e) => {
                                            registerNewCard();
                                        }}
                                        classButton="solid"
                                        size="small"
                                    >
                                        Dodaj kartę
                                    </CustomButtons>{' '}
                                </div>
                            </div>
                        ) : (
                            ''
                        )}
                    </div>
                </main>
            </div>
         
        </>
    );
};

export default Setting;
